import React from 'react'
import { Button } from '@mui/material'
import { FooterContainer } from './styles'
import type { DeleteFooterProps } from './types'

const DeleteFooter: React.FC<DeleteFooterProps> = ({ onClick, t, onClose }) => (
  <FooterContainer>
    <Button color="inherit" variant="text" onClick={onClose}>
      {String(t('common.cancel'))}
    </Button>
    <Button color="primary" variant="contained" onClick={onClick}>
      {String(t('tasks.delete.accept'))}
    </Button>
  </FooterContainer>
)

export default DeleteFooter
